module.exports = __webpack_public_path__ + "static/media/icon-warning.8c216909.svg";